
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/business-decisioning",
      function () {
        return require("private-next-pages/use-cases/business-decisioning.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/business-decisioning"])
      });
    }
  